export const locations = [
  { label: 'Hyderabad', value: 'Hyderabad' },
  { label: 'Noida', value: 'Noida' },
  { label: 'Gurugram', value: 'Gurugram' },
  { label: 'Others', value: 'Others' },
];

export const excludedCities = ['gurugram', 'hyderabad', 'noida'];

export interface QuickLink {
  name: string;
  description: string;
  url: string;
  icon: string;
  svgIcon?: boolean;
}

export const QUICK_LINKS_LEFT: QuickLink[] = [
  {
    name: 'Compliance Gates',
    description: 'Delivery compliance checkpoints',
    url: 'https://cbre.sharepoint.com/sites/intra-TS-ComplianceGates/SitePages/Compliance-Gates.aspx',
    icon: 'grading',
  },
  {
    name: 'AI in SDLC (D&T India)',
    description: 'India AI SDLC overview',
    url: 'https://app.powerbi.com/groups/me/reports/b1f5c3fc-6e59-4e19-87b9-5a7c4b49e5cd/95d51b8dd7cb47060b96?experience=power-bi&clientSideAuth=0',
    icon: 'sync_saved_locally',
    svgIcon: true,
  },
  {
    name: 'AI SDLC (Global)',
    description: 'Global AI SDLC metrics',
    url: 'https://app.powerbi.com/groups/me/reports/eb96f23f-38f2-4f27-b61f-0a2f8ad41ab2/3b5c874a4ac3c69a50e0?experience=power-bi&clientSideAuth=0',
    icon: 'language',
  },
  {
    name: 'TMT',
    description: 'TMT workflow application',
    url: 'https://apps.powerapps.com/play/e/default-0159e9d0-09a0-4edf-96ba-a3deea363c28/a/6cebe091-6111-4fe9-84d5-098b0ce76257?tenantId=0159e9d0-09a0-4edf-96ba-a3deea363c28&hint=9c23c8fa-cbe0-4eb3-b3d6-3752d041a217',
    icon: 'license',
    svgIcon: true,
  },
  {
    name: 'iSkill',
    description: 'Skills & competency tracking',
    url: 'https://apps.powerapps.com/play/e/default-0159e9d0-09a0-4edf-96ba-a3deea363c28/a/d54efa03-edaa-4532-9e37-8c73a2d66e3e?tenantId=0159e9d0-09a0-4edf-96ba-a3deea363c28#',
    icon: 'editor-choice-icon',
    svgIcon: true,
  },
  {
    name: 'R&R',
    description: 'Roles & responsibilities management',
    url: 'https://apps.powerapps.com/play/e/default-0159e9d0-09a0-4edf-96ba-a3deea363c28/a/04344999-69e4-40f3-a0a6-47cabf88e107?tenantId=0159e9d0-09a0-4edf-96ba-a3deea363c28&source=portal',
    icon: 'emoji_events',
  },
  {
    name: 'Leaves',
    description: 'Leave application & tracking',
    url: 'https://lams.cbre.co.in/',
    icon: 'how_to_reg',
  },
  {
    name: 'Payslip',
    description: 'Salary & payslip access',
    url: 'https://ess.cbre.co.in/',
    icon: 'payments',
  },
  {
    name: 'Talent Coach',
    description: 'Learning & career platform',
    url: 'https://cbretalent.csod.com/LMS/catalog/Welcome.aspx?tab_page_id=-67&tab_id=-1',
    icon: 'school',
  },
];

export const QUICK_LINKS_RIGHT: QuickLink[] = [
  {
    name: 'D&T Hub',
    description: 'D&T resources hub',
    url: 'https://cbre.sharepoint.com/teams/DnTHub/SitePages/DnTHub.aspx',
    icon: 'hub',
  },
  {
    name: 'Employee Dashboard',
    description: 'Employee self-service view',
    url: 'https://cbrenow.cbre.com/esc',
    icon: 'dashboard',
  },
  {
    name: 'myCBRE (HCM Portal)',
    description: 'HR & employee services',
    url: 'https://myhcm.cbre.com',
    icon: 'captive_portal',
    svgIcon: true,
  },
  {
    name: 'Contractor Management (extend/disable)',
    description: 'Contractor access management',
    url: 'https://cbre.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_guide_view.do%3Fv%3D1%26sysparm_initial%3Dtrue%26sysparm_guide%3D04268d7b13cd4f00ad00bbc76144b001%26sysparm_link_parent%3D1386d66a4f8f260053f0e57d0210c7d3%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default%26sysparm_view%3Dtext_search',
    icon: 'manage_accounts',
  },
  {
    name: 'Service Now Self-Service Catalog',
    description: 'Service request catalog',
    url: 'https://cbre.service-now.com/now/nav/ui/classic/params/target/catalog_home.do%3Fsysparm_view%3Dcatalog_default',
    icon: 'auto_stories',
  },
  {
    name: 'New Beginnings',
    description: 'Vouchers for new born and marriage',
    url: 'https://apps.powerapps.com/play/e/default-0159e9d0-09a0-4edf-96ba-a3deea363c28/a/8c269d18-0c0c-43a9-bda5-12695e78c99a?tenantId=0159e9d0-09a0-4edf-96ba-a3deea363c28&hint=69d3ec23-bea0-45d4-9683-b9d522bcfb33&sourcetime=1708353271508',
    icon: 'celebration',
  },
  {
    name: 'Employee Handbook',
    description: 'Company policies & guidelines',
    url: 'https://cbre.sharepoint.com/sites/DTIndiaHR/Did%20You%20Know/Forms/AllItems.aspx?id=%2Fsites%2FDTIndiaHR%2FDid%20You%20Know%2FEmployee%20Handbook%20Jun%2D2023%2Epdf&parent=%2Fsites%2FDTIndiaHR%2FDid%20You%20Know&OR=Teams%2DHL&CT=1709651820575&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yNDAyMDExOTMwMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
    icon: 'menu_book',
  },
  {
    name: 'CBRE Brand centre (for Corporate templates)',
    description: 'Brand assets & templates',
    url: 'https://brand.cbre.com/content/corporate-download',
    icon: 'view_comfy',
  },
];